module.exports = __webpack_public_path__ + "img/broadcast.7ab79550.png";